/**
 * Pill-shaped filter toggle. Maps to the existing App.css .filter-chip classes.
 *
 * Props:
 *   active    — whether the chip is in the selected state (default: false)
 *   className — extra class(es) on the button
 *
 * All other props (onClick, disabled, title, aria-*) pass through.
 */
export default function FilterChip({ active = false, className = '', children, ...props }) {
  const classes = ['filter-chip', active ? 'filter-chip--active' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type="button" className={classes} aria-pressed={active} {...props}>
      {children}
    </button>
  );
}
